import { sdkApi } from 'redux-stores/api';
import { thunk } from 'redux-stores';
import { OrganizationSettings } from 'admin/types';

const personaApi = sdkApi.injectEndpoints({
  endpoints: (build) => ({
    getPersonasStatus: build.query<OrganizationSettings, { orgId: string }>({
      queryFn: async ({ orgId }, _queryApi) => {
        const settings = await thunk.findSettings(orgId);
        return { data: settings };
      },
    }),
  }),
});

export const { useGetPersonasStatusQuery } = personaApi;
